import { handleActions } from 'redux-actions';
import * as executorsActions from '../actions/executorsActions';

let initState = {
  allExecutors: null,
  allExecutorsStat: null,
  filterExecutors: null,
  filterExecutorsStat: null,
  isLoading: false,
  errorMessage: '',
};

export const executors = handleActions(
  {
    [executorsActions.getAllExecutors]: state => {
      return { ...state, isLoading: true };
    },
    [executorsActions.getAllExecutorsSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        allExecutors: payload.executors,
        executorsTypes: payload.executorsTypes,
        allExecutorsStat: payload.executorsStat,
        isLoading: false,
      };
    },
    [executorsActions.getAllExecutorsFailure]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        isLoading: false,
      };
    },
    [executorsActions.getFilterExecutors]: state => {
      return { ...state, isLoading: true };
    },
    [executorsActions.getFilterExecutorsSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        filterExecutors: payload.executors,
        filterExecutorsStat: payload.executorsStat,
        isLoading: false,
      };
    },
    [executorsActions.getFilterExecutorsError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        isLoading: false,
      };
    },
  },
  initState
);
